import type { InferProps } from 'prop-types';
import type { FunctionComponent } from 'react';

import DatePicker, { type propTypes } from './date-picker';

export default DatePicker as FunctionComponent<InferProps<typeof propTypes>>;
